import { Card, Pill, Stack, Text } from '@/design-system'
import { PageHeader } from '@/app/layouts/PageHeader'
import { Media } from '@/components/Media'
import { PHOTO_CREDITS } from '@/content/photo-credits'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

export function CreditsScreen() {
  const mustAttribute = PHOTO_CREDITS.filter((credit) => credit.attributionRequired)

  return (
    <>
      <PageHeader
        title="Photography"
        subtitle="Every photograph in the app, who made it and under what licence."
      />

      <Card tone="light">
        <Card.Header>
          <Text variant="caption" weight="semibold">
            {PHOTO_CREDITS.length} photographs
          </Text>
          <Pill tone="neutral">{mustAttribute.length} require credit</Pill>
        </Card.Header>
        <Text variant="caption" tone="secondary" className="pb-mt-3">
          The rest are CC0 or public domain and carry no attribution requirement. We list them
          anyway, because knowing where an image came from is worth more than the licence asking.
        </Text>

        <Stack gap={0} className="pb-mt-4">
          {PHOTO_CREDITS.map((credit) => (
            <div key={credit.file} className={checkout.line}>
              <Media src={credit.file} alt="" width={48} ratio={1} radius="md" />
              <Stack grow gap={0} align="start">
                <Text variant="caption" weight="semibold" truncate>
                  {credit.title}
                </Text>
                <Text variant="eyebrow" tone="secondary" truncate>
                  {credit.creator} · {credit.file}
                </Text>
              </Stack>
              <Pill tone={credit.attributionRequired ? 'accent' : 'neutral'}>{credit.license}</Pill>
            </div>
          ))}
        </Stack>
      </Card>
    </>
  )
}
